/* src/app/pages/credit-cards/edit-contracted-product-modal/edit-contracted-product-modal.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
h1,
h2,
h3,
h4,
h5,
h6,
label,
p,
b,
small,
span,
strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
h1.cds-required::after,
h2.cds-required::after,
h3.cds-required::after,
h4.cds-required::after,
h5.cds-required::after,
h6.cds-required::after,
label.cds-required::after,
p.cds-required::after,
b.cds-required::after,
small.cds-required::after,
span.cds-required::after,
strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
h1[class^=c-],
h2[class^=c-],
h3[class^=c-],
h4[class^=c-],
h5[class^=c-],
h6[class^=c-],
label[class^=c-],
p[class^=c-],
b[class^=c-],
small[class^=c-],
span[class^=c-],
strong[class^=c-] {
  color: var(--color);
}
b,
strong,
span {
  font-family: var(--cds-font-family);
}
h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
p.bold {
  font-weight: bold;
}
label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
.modal-body {
  display: flex;
  flex-direction: column;
  box-shadow:
    0px 6px 6px -3px hsla(var(--cds-shadow-600-hsl), 0.12),
    0px 10px 14px 1px hsla(var(--cds-shadow-600-hsl), 0.09),
    0px 4px 18px 3px hsla(var(--cds-shadow-600-hsl), 0.08);
  padding: 40px;
  width: 489px;
  border-radius: 8px;
  background: var(--cds-background-main);
  position: relative;
  gap: 16px;
}
.modal-body hr {
  width: 100%;
  height: 0;
  border: none;
  border-top: 1px solid var(--cds-border);
  margin: 0;
}
.modal-body button {
  align-self: flex-end;
  height: 44px;
}
.modal-body .close-button {
  color: var(--cds-text-primary);
}
.modal-body .icon-edit {
  font-size: 42px;
  color: var(--cds-text-secondary);
}
.modal-body .title {
  font-size: 20px;
}
.modal-body .text-bold {
  font-weight: 600;
  color: var(--cds-text-strong);
}
.modal-body .text-center {
  text-align: center;
  line-height: 150%;
}
.modal-body .product-name {
  font-size: 24px;
}
.input-container {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.input-container .character-count {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: --cds-text-disabled;
  line-height: 1;
}
label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  line-height: 1;
}
label.ec-name {
  display: flex;
  justify-content: space-between;
}
label.ec-name i {
  font-size: 12px;
  color: var(--cds-icon-medium);
}
/*# sourceMappingURL=edit-contracted-product-modal.component.css.map */
